
import React from "react";
import '../css/header.css'

function Main() {
    return (
        <div className="Header">
            <ul className="gnb">
                <li><a href="#">Main</a></li>
                <li><a href="#">About</a></li>
                <li><a href="#">Porfolio</a></li>
                <li><a href="#">Work</a></li>
            </ul>
        </div>
        
    )
}
export default Main;